// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"Navigationitems_NavigationItems__1V1ru"};